import { SETTING_TO_GROUP_TYPE, GROUP_TYPE_SET_SUCCESS, GROUP_TYPE_SET_FAILED } from './types';
import { history, HiverAxios, SET_ONBOARDING_MODE, isExtensionInstalled, showMessage, setSessionIdToUrl, sendTrackingEvent, dispatchApprovalEvent } from 'h-commons';
import { INSTRUMENTATION_TRACKING_EVENTS } from '../../../common';
import { constants } from '../constants';
const SM_SET_GROUP_TYPE = '/gx/api/sm/setgrouptype';

/**
 * Dispatches show message action, to show message
 * @param {Function} dispatch 
 * @param {String} type
 * @param {String} message
 */
function dispatchMessage(type, message) {
    if (type === 'success')
        showMessage({ message, type: 'success' });
    else if (type === 'error')
        showMessage({ message, type: 'error' });
}
/**
 * Action responsible for creating post request to change smtype to grouptype
 * @param {Number} smid the smid for which group type change needs to be done
 */
export function setToGroupType(smid, email, gmailMode, onboarding, userSession, onSuccess) {
    return (dispatch) => {
        dispatch({
            type: SETTING_TO_GROUP_TYPE
        });
        HiverAxios({
            url: SM_SET_GROUP_TYPE,
            type: 'post',
            params: { "smid": smid },
            callback: (response) => {
                const { status } = response.data;
                if (status === "success") {
                    dispatch({
                        type: GROUP_TYPE_SET_SUCCESS,
                        payload: response.data
                    });
                    dispatchApprovalEvent('TOKEN_EXPIRED');
                    const extensionInstalled = gmailMode ? true : isExtensionInstalled();
                    if (onboarding) {
                        sendTrackingEvent(INSTRUMENTATION_TRACKING_EVENTS.FirstEmailSMCreated, { smType: constants.GROUP_TYPE });
                        dispatch({
                            type: SET_ONBOARDING_MODE, payload: {
                                type: 'group', smid, email, extensionInstalled
                            }
                        });
                        history.push(setSessionIdToUrl('/app/sm-onboarding-done', userSession));
                    } else {
                        dispatch({ type: SET_ONBOARDING_MODE, payload: null });
                        history.push(setSessionIdToUrl('/app/sharedmailbox', userSession));
                    }
                    onSuccess();
                    dispatchMessage('success', 'Setup successful. Your Shared Mailbox is ready to use');
                    sendTrackingEvent('smValidated');
                } else {
                    dispatchMessage('error', 'Something went wrong, please contact support@hiverhq.com');
                    dispatch({
                        type: GROUP_TYPE_SET_FAILED
                    });
                }
            },
            onfail: () => {
                dispatch({
                    type: GROUP_TYPE_SET_FAILED
                });
                dispatchMessage('error', 'Something went wrong, please contact support@hiverhq.com');
            }
        });
    };
}